<template>
  <div class="soha-menu-box sticky-sidebar">
    <div
      v-for="(menu, index) in menus"
      :key="menu.routeName"
      class="soha-side-menu-item"
    >
      <router-link
        class="primary-color px-2 w-100 h-100 py-3 d-block"
        :to="{ path: menu.url }"
      >
        {{ menu.name }}
      </router-link>
      <span
        v-if="index != menus.length - 1"
        class="soha-seprator-horizontal-menu"
      >
        |
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/base/side-menu.css";

export default {
  name: "SideMenu",

  props: {
    menus: {
      type: Array,
      require: true,
    },
  },
};
</script>
